<template>
<div>
  <w-search-field v-if="showSearchTool === true" class="title-bar" :width="searchWidth" @search="searchTree"/>
  <el-tree
    class="tree-w-stroke obj-tree"
    v-loading="rootLoading"
    :ref="treeRef"
    lazy
    :load="loadData"
    :props="defaultProps"
    :node-key="defaultProps.treeKey"
    :expand-on-click-node="expandOnClickNode"
    highlight-current
    @node-click="onClickNode"
  >
  <span class="el-tree-node__label" slot-scope="{ node, data }">
    <el-tooltip v-if="isObjNode(data) && isRequireIPObjType(data)" class="item" effect="dark" :content="getIpTooltipContent(data)" placement="right">
      <span>
        <span>{{getObjNodeLabel(data)}}</span>
      </span>
    </el-tooltip>
    <span v-else-if="isObjNode(data)">
      <span>{{data.label}}</span>
    </span>
    <span v-else>
      <span class="group">{{data.label}}</span>
    </span>
  </span>
  </el-tree>
</div>
</template>

<script>
import { assign, isEmpty, isArray, isNil } from 'lodash';
import TreeApi from '@/api/common/tree';
import { findFirstLeafTreeKey, getPathNodes, isObjNode, isRequireIPObjType, getObjNodeLabel, getIpTooltipContent } from '@/utils/tree';
import { defaultProps, treeType } from '@/constants/tree';
import MsgUtil from '@/utils/message';
import SearchLimitMixin from '@/mixins/tree/search-limit';
import DynamicTreeMixin from '@/mixins/tree/dynamic-tree';
import DynamicTargetTreeMixin from '@/components/tree/TargetTree/mixins/dynamic-tree';
import WSearchField from '@/components/form/SearchField';

export default {
  name: 'WPhysicalTree',
  components: {
    WSearchField,
  },
  mixins: [DynamicTreeMixin, DynamicTargetTreeMixin, SearchLimitMixin],
  props: {
    /**
     * leaf 노드만 선택되도록 한다.
     * @type {Boolean}
     */
    forceSelectLeaf: {
      type: Boolean,
      default: false,
    },
    managetypeId: {
      type: String,
      default: null,
    },
    expandOnClickNode: {
      type: Boolean,
      default: true,
    },
    showSearchTool: {
      type: Boolean,
      default: true,
    },
    searchWidth: {
      type: String,
      default: '100%',
    },
    isNetdeviceLeafNode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      treeRef: 'tree',
      selectedNode: null,
      defaultProps,
      treeType: treeType.PHYSICAL,
    };
  },
  methods: {
    isObjNode,
    isRequireIPObjType,
    getObjNodeLabel,
    getIpTooltipContent,
    loadData(node, resolve) {
      if (node.level === 0 && this.loading === true) {
        return;
      }
      const params = assign(this.getBaseParams(node), { managetypeId: this.managetypeId, forceSelectLeaf: this.forceSelectLeaf, isNetdeviceLeafNode: this.isNetdeviceLeafNode });
      if ((isNil(this.searchKeyword) || this.searchKeyword === '') && node.level === 0 && !isEmpty(this.selectedNode)) {
        params.initTreeKey = this.selectedNode.data.treeKey;
      }
      this.loading = true;
      if (node.level === 0) {
        this.rootLoading = true;
      }
      this.loading = true;
      TreeApi.getPhysicalTreeData(params)
        .then((response) => {
          if (response.data.success) {
            const children = isArray(response.data.children) ? response.data.children : [response.data.children];
            resolve(children);
            // load시 마다 선택된 노드 유지되도록 함. (또는 watch 이용)
            this.$nextTick(() => {
              const tree = this.getTree();
              this.createChildNodes(children, tree);
              if (!isNil(this.searchKeyword) && this.searchKeyword !== '') {
                this.setLoadedStatusToAllTreeNodes();
              }

              let selectedNode;
              const root = isEmpty(this.$refs[this.treeRef].root.childNodes) ? null : this.$refs[this.treeRef].root.childNodes[0];
              if (!isEmpty(this.selectedNode)) {
                selectedNode = tree.getNode(this.selectedNode.data.treeKey);
                if (!isEmpty(selectedNode)) {
                  this.selectedNode = selectedNode;
                }
              } else if (this.forceSelectLeaf === true) {
                const treeKey = findFirstLeafTreeKey(root);
                if (treeKey === null) {
                  selectedNode = root;
                } else {
                  selectedNode = tree.getNode(treeKey) || root;
                }
              } else {
                selectedNode = root;
              }

              if (!isEmpty(selectedNode)) {
                const pathNodes = getPathNodes(selectedNode);
                pathNodes.forEach((item) => {
                  if (!item.isLeaf) {
                    item.expanded = true;
                  }
                });
                this.selectedNode = selectedNode;
                tree.setCurrentKey(selectedNode.data.treeKey);
                this.$emit('clickNode', this.selectedNode.data, this.selectedNode);
              }
              this.$emit('load');
            });
            // this.setChildren(resolve, response.data.children);
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '물리 그룹 트리 정보', false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '물리 그룹 트리 정보', false));
          throw new Error(e);
        })
        .finally(() => {
          this.rootLoading = false;
          this.loading = false;
        });
    },
    getTree() {
      return this.$refs[this.treeRef];
    },
    getCurrentNode() {
      return this.getTree().getCurrentNode() || this.selectdNode;
    },
    onClickNode(data, node, nodeCmp) {
      if (this.forceSelectLeaf === true) {
        if (node.isLeaf === true) {
          this.selectedNode = node;
          this.$emit('clickNode', data, node);
        } else {
          nodeCmp.$el.blur();
          let selectedNode;
          if (!isEmpty(this.selectedNode)) {
            selectedNode = this.getTree().getNode(this.selectedNode.data.treeKey);
          } else {
            const root = isEmpty(this.$refs[this.treeRef].root.childNodes) ? null : this.$refs[this.treeRef].root.childNodes[0];
            const treeKey = findFirstLeafTreeKey(root);
            selectedNode = this.getTree().getNode(treeKey);
            this.selectdNode = selectedNode;
          }

          if (!isEmpty(selectedNode)) {
            this.getTree().setCurrentKey(selectedNode.data.treeKey);
          }
        }
      } else {
        this.selectedNode = node;
        this.$emit('clickNode', data, node);
      }
    },
    searchTree(value) {
      const checkSearchable = this.checkSearchableKeyword(value);
      this.messageInfo = null;
      if (checkSearchable.searchable) {
        this.filterTree(value);
      } else if (!isNil(checkSearchable.message)) {
        this.$message(MsgUtil.getCustomMsgData(checkSearchable.message));
      }
    },
    clearSelectedNode() {
      this.selectedNode = null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tree/DynamicPhysicalTree.vue